export const HEADER_HEIGHT = 80;

export const ANCHORS = [
    { id: "inicio", label: "Início" },
    { id: "sobre", label: "Sobre" },
    { id: "videos", label: "Vídeos" },
    { id: "fotos", label: "Fotos" },
    { id: "equipe", label: "Equipe" },
    { id: "numeros", label: "Números" },
    { id: "contato", label: "Contato" },
];